module.exports = __webpack_public_path__ + "static/media/about_pier84.03790982.jpg";